// @core/api/endpoints/affiliate/create_commission_tier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CommissionTierResponse,
  CreateCommissionTierRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Create commission tier
 * Creates a new commission tier with the provided data. Returns the created resource.
 */
export async function CreateCommissionTier(
  data: CreateCommissionTierRequest,
  options?: RequestOptions
): Promise<CommissionTierResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/commission-tiers`;
  const requestOptions = options;
  return client.post<CommissionTierResponse>(requestPath, data, requestOptions);
}
